module.exports = __webpack_public_path__ + "static/media/dealiem_privacy_policy.8ac522e3.pdf";